export default {"src":"/_next/static/media/seedkit_logo_black.7e64eb42.svg","height":33,"width":114,"blurWidth":0,"blurHeight":0};